document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('meal-search');
  const resultsCount = document.getElementById('results-count');
  const allMealCardGrids = document.querySelectorAll('.meals-list-with-search__meal-cards-grid');
  const firstMealCardsGrid = allMealCardGrids[0]; // First list section grid
  const otherMealCardGrids = Array.from(allMealCardGrids).slice(1); // All grids except the first

  // Function to move all meal cards to the first grid and hide other sections
  function consolidateMealCards() {
    otherMealCardGrids.forEach((grid) => {
      while (grid.children.length > 0) {
        firstMealCardsGrid.appendChild(grid.children[0]); // Move the first child until grid is empty
      }
      grid.closest('.meals-list-with-search').style.display = 'none'; // Hide the parent section
    });
  }

  // Call the consolidateMealCards function
  consolidateMealCards();

  // Function to filter meal cards based on search input
  function filterMeals() {
    const keyword = searchInput.value.toLowerCase();
    let count = 0;

    const mealCards = firstMealCardsGrid.querySelectorAll('.meal-card-link'); // Updated to only target cards in the first grid
    mealCards.forEach((card) => {
      const title = card.getAttribute('data-title').toLowerCase();
      if (title.includes(keyword)) {
        card.style.display = 'block';
        count++;
      } else {
        card.style.display = 'none';
      }
    });

    resultsCount.textContent = keyword ? `Showing ${count} results for "${keyword}"` : 'All results';
  }

  // Attach event listener to search input
  searchInput.addEventListener('input', filterMeals);
});
